import React from "react";
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const BGI = [13.074, -59.492];

function altColor(ft) {
  if (ft == null || ft < 1000) return "#F59E0B";
  if (ft < 12000) return "#14B8A6";
  if (ft < 25000) return "#3B6DE0";
  return "#1E4DB7";
}

const planeIcon = (track, color) =>
  L.divIcon({
    className: "go-plane-icon",
    html: `<div style="transform:translate(-50%,-50%) rotate(${track || 0}deg)">
      <i class="fa-solid fa-plane" style="display:block;transform:rotate(-45deg);color:${color};font-size:15px;filter:drop-shadow(0 1px 2px rgba(0,0,0,.4))"></i>
    </div>`,
    iconSize: [15, 15], iconAnchor: [0, 0],
  });

const focusIcon = (track) =>
  L.divIcon({
    className: "go-plane-icon",
    html: `<div style="transform:translate(-50%,-50%) rotate(${track || 0}deg)">
      <div class="go-userdot-ping" style="position:absolute;inset:-8px;width:34px;height:34px;border-radius:50%;background:rgba(255,199,38,.35)"></div>
      <i class="fa-solid fa-plane" style="display:block;transform:rotate(-45deg);color:#FFC726;font-size:20px;filter:drop-shadow(0 0 6px #FFC726)"></i>
    </div>`,
    iconSize: [20, 20], iconAnchor: [0, 0],
  });

const bgiIcon = L.divIcon({
  className: "go-plane-icon",
  html: `<div style="transform:translate(-50%,-50%);width:14px;height:14px;border-radius:50%;background:#EF4444;border:3px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.35)"></div>`,
  iconSize: [14, 14], iconAnchor: [0, 0],
});

function Fitter({ points, focus }) {
  const map = useMap();
  React.useEffect(() => {
    if (focus) map.setView([focus.lat, focus.lon], 9, { animate: true });
    else if (points.length > 1) map.fitBounds(points, { padding: [30, 30], maxZoom: 8 });
  }, [points, focus, map]);
  return null;
}

const AircraftMiniMap = ({ airspace, focus }) => {
  const craft = (airspace?.aircraft || []).filter((a) => a.lat && a.lon);
  const points = [BGI, ...craft.map((a) => [a.lat, a.lon])];

  return (
    <div className="relative overflow-hidden rounded-[1.75rem]" style={{ height: 240, boxShadow: "0 4px 20px rgba(0,0,0,0.4)" }} data-testid="aircraft-minimap">
      <MapContainer center={BGI} zoom={7} zoomControl={false} attributionControl={false} className="h-full w-full">
        <TileLayer url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png" />
        <Marker position={BGI} icon={bgiIcon} />
        {craft.map((a, i) => {
          const isFocus = focus && focus.flight === a.flight;
          return <Marker key={i} position={[a.lat, a.lon]} icon={isFocus ? focusIcon(a.track) : planeIcon(a.track, altColor(a.alt_ft))} />;
        })}
        <Fitter points={points} focus={focus} />
      </MapContainer>
      <div className="pointer-events-none absolute left-3 top-3 flex items-center gap-2 rounded-full bg-[#0A1428]/85 px-3 py-1.5 ring-1 ring-white/10 backdrop-blur" style={{ boxShadow: "0 2px 10px rgba(0,0,0,0.4)" }}>
        <span className="go-blip inline-block h-2 w-2 rounded-full bg-[#5B9BFF]" />
        <span className="text-xs font-bold text-white" data-testid="aircraft-count">{airspace?.count ?? craft.length} aircraft near Barbados</span>
      </div>
    </div>
  );
};

export default AircraftMiniMap;
